import { ShieldAlert, Flame, HeartPulse, Car, AlertTriangle, TrafficCone, MapPin } from "lucide-react";

export const typeIcons = {
  security: ShieldAlert,
  fire: Flame,
  medical: HeartPulse,
  accident: Car,
  banditry: AlertTriangle,
  ecaution: TrafficCone,
  location_share: MapPin,
};

export const typeColors = {
  security: "bg-red-100 text-red-800 hover:bg-red-100",
  fire: "bg-orange-100 text-orange-800 hover:bg-orange-100",
  medical: "bg-blue-100 text-blue-800 hover:bg-blue-100",
  accident: "bg-yellow-100 text-yellow-800 hover:bg-yellow-100",
  banditry: "bg-rose-100 text-rose-900 hover:bg-rose-100",
  ecaution: "bg-amber-100 text-amber-800 hover:bg-amber-100",
  location_share: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100",
};

export const typeIconColor = {
  security: "#EF4444",
  fire: "#F97316",
  medical: "#3B82F6",
  accident: "#EAB308",
  banditry: "#881337",
  ecaution: "#D97706",
  location_share: "#059669",
};

export const VOTABLE_TYPES = new Set(["security", "fire", "medical", "accident", "banditry", "ecaution"]);

export function formatTime(isoStr, t = null) {
  const d = new Date(isoStr);
  const now = new Date();
  const diff = (now - d) / 1000;
  if (diff < 60) return t ? t("alert_feed.just_now") : "Just now";
  if (diff < 3600) return t ? t("alert_feed.minutes_ago", { n: Math.floor(diff / 60) }) : `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return t ? t("alert_feed.hours_ago", { n: Math.floor(diff / 3600) }) : `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
